import {
  FETCH_NETWORK_DEVICE_TYPE_LIST,
  RESET_NETWORK_DEVICE_TYPE_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {
    total: 0,
    offset: 0,
    limit: 10,
  },
};

const networkDeviceTypeList = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NETWORK_DEVICE_TYPE_LIST:
      return { list: action.payload, others: action.others };
    case RESET_NETWORK_DEVICE_TYPE_LIST:
      return initialState;
    default:
      return state;
  }
};

export default networkDeviceTypeList;
